//# sourceMappingURL=content_library.mjs.map
/// <reference types="./content_library.d.mts" />
import * as $connector from "../../data_types/data/connector.mjs";
import * as $data_source from "../../data_types/data/data_source.mjs";
import { DataSource } from "../../data_types/data/data_source.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import {
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
} from "../gleam.mjs";

export class NewQna extends $CustomType {
  constructor(question, answer, loading, existing_document) {
    super();
    this.question = question;
    this.answer = answer;
    this.loading = loading;
    this.existing_document = existing_document;
  }
}
export const NewQna$NewQna = (question, answer, loading, existing_document) =>
  new NewQna(question, answer, loading, existing_document);
export const NewQna$isNewQna = (value) => value instanceof NewQna;
export const NewQna$NewQna$question = (value) => value.question;
export const NewQna$NewQna$0 = (value) => value.question;
export const NewQna$NewQna$answer = (value) => value.answer;
export const NewQna$NewQna$1 = (value) => value.answer;
export const NewQna$NewQna$loading = (value) => value.loading;
export const NewQna$NewQna$2 = (value) => value.loading;
export const NewQna$NewQna$existing_document = (value) =>
  value.existing_document;
export const NewQna$NewQna$3 = (value) => value.existing_document;

export class Sources extends $CustomType {
  constructor(all, all_size, verified, verified_size, pending, pending_size, not_verified, not_verified_size, outdated, outdated_size) {
    super();
    this.all = all;
    this.all_size = all_size;
    this.verified = verified;
    this.verified_size = verified_size;
    this.pending = pending;
    this.pending_size = pending_size;
    this.not_verified = not_verified;
    this.not_verified_size = not_verified_size;
    this.outdated = outdated;
    this.outdated_size = outdated_size;
  }
}
export const Sources$Sources = (all, all_size, verified, verified_size, pending, pending_size, not_verified, not_verified_size, outdated, outdated_size) =>
  new Sources(all,
  all_size,
  verified,
  verified_size,
  pending,
  pending_size,
  not_verified,
  not_verified_size,
  outdated,
  outdated_size);
export const Sources$isSources = (value) => value instanceof Sources;
export const Sources$Sources$all = (value) => value.all;
export const Sources$Sources$0 = (value) => value.all;
export const Sources$Sources$all_size = (value) => value.all_size;
export const Sources$Sources$1 = (value) => value.all_size;
export const Sources$Sources$verified = (value) => value.verified;
export const Sources$Sources$2 = (value) => value.verified;
export const Sources$Sources$verified_size = (value) => value.verified_size;
export const Sources$Sources$3 = (value) => value.verified_size;
export const Sources$Sources$pending = (value) => value.pending;
export const Sources$Sources$4 = (value) => value.pending;
export const Sources$Sources$pending_size = (value) => value.pending_size;
export const Sources$Sources$5 = (value) => value.pending_size;
export const Sources$Sources$not_verified = (value) => value.not_verified;
export const Sources$Sources$6 = (value) => value.not_verified;
export const Sources$Sources$not_verified_size = (value) =>
  value.not_verified_size;
export const Sources$Sources$7 = (value) => value.not_verified_size;
export const Sources$Sources$outdated = (value) => value.outdated;
export const Sources$Sources$8 = (value) => value.outdated;
export const Sources$Sources$outdated_size = (value) => value.outdated_size;
export const Sources$Sources$9 = (value) => value.outdated_size;

export class ContentLibrary extends $CustomType {
  constructor(non_qna_sources, selected, change_owner_popup_opened, change_status_popup_opened, change_tags_popup_opened, change_expiration_date_popup_opened, change_expiration_date_input, filter_selected, search, new_qna, ingestion_loading) {
    super();
    this.non_qna_sources = non_qna_sources;
    this.selected = selected;
    this.change_owner_popup_opened = change_owner_popup_opened;
    this.change_status_popup_opened = change_status_popup_opened;
    this.change_tags_popup_opened = change_tags_popup_opened;
    this.change_expiration_date_popup_opened = change_expiration_date_popup_opened;
    this.change_expiration_date_input = change_expiration_date_input;
    this.filter_selected = filter_selected;
    this.search = search;
    this.new_qna = new_qna;
    this.ingestion_loading = ingestion_loading;
  }
}
export const ContentLibrary$ContentLibrary = (non_qna_sources, selected, change_owner_popup_opened, change_status_popup_opened, change_tags_popup_opened, change_expiration_date_popup_opened, change_expiration_date_input, filter_selected, search, new_qna, ingestion_loading) =>
  new ContentLibrary(non_qna_sources,
  selected,
  change_owner_popup_opened,
  change_status_popup_opened,
  change_tags_popup_opened,
  change_expiration_date_popup_opened,
  change_expiration_date_input,
  filter_selected,
  search,
  new_qna,
  ingestion_loading);
export const ContentLibrary$isContentLibrary = (value) =>
  value instanceof ContentLibrary;
export const ContentLibrary$ContentLibrary$non_qna_sources = (value) =>
  value.non_qna_sources;
export const ContentLibrary$ContentLibrary$0 = (value) => value.non_qna_sources;
export const ContentLibrary$ContentLibrary$selected = (value) => value.selected;
export const ContentLibrary$ContentLibrary$1 = (value) => value.selected;
export const ContentLibrary$ContentLibrary$change_owner_popup_opened = (value) =>
  value.change_owner_popup_opened;
export const ContentLibrary$ContentLibrary$2 = (value) =>
  value.change_owner_popup_opened;
export const ContentLibrary$ContentLibrary$change_status_popup_opened = (value) =>
  value.change_status_popup_opened;
export const ContentLibrary$ContentLibrary$3 = (value) =>
  value.change_status_popup_opened;
export const ContentLibrary$ContentLibrary$change_tags_popup_opened = (value) =>
  value.change_tags_popup_opened;
export const ContentLibrary$ContentLibrary$4 = (value) =>
  value.change_tags_popup_opened;
export const ContentLibrary$ContentLibrary$change_expiration_date_popup_opened = (value) =>
  value.change_expiration_date_popup_opened;
export const ContentLibrary$ContentLibrary$5 = (value) =>
  value.change_expiration_date_popup_opened;
export const ContentLibrary$ContentLibrary$change_expiration_date_input = (value) =>
  value.change_expiration_date_input;
export const ContentLibrary$ContentLibrary$6 = (value) =>
  value.change_expiration_date_input;
export const ContentLibrary$ContentLibrary$filter_selected = (value) =>
  value.filter_selected;
export const ContentLibrary$ContentLibrary$7 = (value) => value.filter_selected;
export const ContentLibrary$ContentLibrary$search = (value) => value.search;
export const ContentLibrary$ContentLibrary$8 = (value) => value.search;
export const ContentLibrary$ContentLibrary$new_qna = (value) => value.new_qna;
export const ContentLibrary$ContentLibrary$9 = (value) => value.new_qna;
export const ContentLibrary$ContentLibrary$ingestion_loading = (value) =>
  value.ingestion_loading;
export const ContentLibrary$ContentLibrary$10 = (value) =>
  value.ingestion_loading;

export function init_new_qna() {
  return new NewQna("", "", false, new $option.None());
}

function compute_sources(all) {
  let verified = $list.filter(
    all,
    (s) => { return s.status instanceof $data_source.Verified; },
  );
  let pending = $list.filter(
    all,
    (s) => { return s.status instanceof $data_source.Pending; },
  );
  let not_verified = $list.filter(
    all,
    (s) => { return s.status instanceof $data_source.NotVerified; },
  );
  let outdated = $list.filter(
    all,
    (s) => { return s.status instanceof $data_source.Outdated; },
  );
  return new Sources(
    all,
    $list.length(all),
    verified,
    $list.length(verified),
    pending,
    $list.length(pending),
    not_verified,
    $list.length(not_verified),
    outdated,
    $list.length(outdated),
  );
}

export function new$() {
  let now = $timestamp.system_time();
  let change_expiration_date_input = $timestamp_.to_date_yyyymmdd(now, "-");
  return new ContentLibrary(
    compute_sources(toList([])),
    $dict.new$(),
    false,
    false,
    false,
    false,
    change_expiration_date_input,
    new $option.None(),
    "",
    init_new_qna(),
    false,
  );
}

export function set_filter(content_library, filter) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    content_library.selected,
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    filter,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

function do_upsert_data_source(loop$sources, loop$results, loop$source) {
  while (true) {
    let sources = loop$sources;
    let results = loop$results;
    let source = loop$source;
    if (sources instanceof $Empty) {
      return $list.reverse(results);
    } else {
      let s = sources.head;
      if (s.id === source.id) {
        let rest = sources.tail;
        let _pipe = $list.reverse(results);
        return $list.append(_pipe, listPrepend(source, rest));
      } else {
        let s = sources.head;
        let rest = sources.tail;
        loop$sources = rest;
        loop$results = listPrepend(s, results);
        loop$source = source;
      }
    }
  }
}

export function upsert_data_source(content_library, source) {
  let _pipe = do_upsert_data_source(
    content_library.non_qna_sources.all,
    toList([]),
    source,
  );
  let _pipe$1 = compute_sources(_pipe);
  return ((non_qna_sources) => {
    return new ContentLibrary(
      non_qna_sources,
      content_library.selected,
      content_library.change_owner_popup_opened,
      content_library.change_status_popup_opened,
      content_library.change_tags_popup_opened,
      content_library.change_expiration_date_popup_opened,
      content_library.change_expiration_date_input,
      content_library.filter_selected,
      content_library.search,
      content_library.new_qna,
      content_library.ingestion_loading,
    );
  })(_pipe$1);
}

export function set_non_qna_sources(content_library, sources) {
  let non_qna_sources = compute_sources(sources);
  return new ContentLibrary(
    non_qna_sources,
    content_library.selected,
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function set_data_sources(content_library, sources) {
  let sources$1 = $list.filter(
    sources,
    (s) => { return !(s.kind instanceof $connector.SteerlabQna); },
  );
  let _pipe = content_library;
  return set_non_qna_sources(_pipe, sources$1);
}

export function close_popups(content_library) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    content_library.selected,
    false,
    false,
    false,
    false,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function set_new_qna(content_library, new_qna) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    content_library.selected,
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    new_qna,
    content_library.ingestion_loading,
  );
}

export function filtered_non_qna_sources(content_library) {
  let sources = content_library.non_qna_sources;
  let $ = content_library.filter_selected;
  if ($ instanceof $option.Some) {
    let $1 = $[0];
    if ($1 instanceof $data_source.Pending) {
      return sources.pending;
    } else if ($1 instanceof $data_source.Verified) {
      return sources.verified;
    } else if ($1 instanceof $data_source.NotVerified) {
      return sources.not_verified;
    } else if ($1 instanceof $data_source.Outdated) {
      return sources.outdated;
    } else {
      return sources.all;
    }
  } else {
    return sources.all;
  }
}

export function is_selected(content_library, id) {
  let _pipe = $dict.get(content_library.selected, id);
  return $result.unwrap(_pipe, false);
}

export function select(content_library, id) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    $dict.insert(content_library.selected, id, true),
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function deselect(content_library, id) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    $dict.delete$(content_library.selected, id),
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function toggle_change_status(content_library) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    content_library.selected,
    false,
    !content_library.change_status_popup_opened,
    false,
    false,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function deselect_all(content_library) {
  return new ContentLibrary(
    content_library.non_qna_sources,
    $dict.new$(),
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

function update_sources(content_library, sources, mapper) {
  return $list.map(
    sources,
    (source) => {
      let is_selected$1 = is_selected(content_library, source.id);
      return $bool.guard(
        !is_selected$1,
        source,
        () => { return mapper(source); },
      );
    },
  );
}

function update_selected_sources(content_library, mapper) {
  let sources = content_library.non_qna_sources.all;
  let _block;
  let _record = content_library.non_qna_sources;
  _block = new Sources(
    update_sources(content_library, sources, mapper),
    _record.all_size,
    _record.verified,
    _record.verified_size,
    _record.pending,
    _record.pending_size,
    _record.not_verified,
    _record.not_verified_size,
    _record.outdated,
    _record.outdated_size,
  );
  let updated_non_qa_source = _block;
  return new ContentLibrary(
    updated_non_qa_source,
    content_library.selected,
    content_library.change_owner_popup_opened,
    content_library.change_status_popup_opened,
    content_library.change_tags_popup_opened,
    content_library.change_expiration_date_popup_opened,
    content_library.change_expiration_date_input,
    content_library.filter_selected,
    content_library.search,
    content_library.new_qna,
    content_library.ingestion_loading,
  );
}

export function attribute_status(content_library, status) {
  let set_status = (s) => {
    return new DataSource(
      s.id,
      status,
      s.display,
      s.kind,
      s.authors,
      s.owner,
      s.document_id,
      s.blob_link,
      s.content_link,
      s.hash,
      s.version,
      s.tags,
      s.org_id,
      s.expiration_date,
    );
  };
  let _pipe = content_library;
  return update_selected_sources(_pipe, set_status);
}

export function extract_selected_source_ids(sources_selected) {
  return $dict.fold(
    sources_selected,
    toList([]),
    (ids, key, value) => {
      return $bool.guard(!value, ids, () => { return listPrepend(key, ids); });
    },
  );
}
